<div class="p1">
  <div class="flex flex-column pb1">
    @if (schema.title) {
      <h2 class="h3 bold mb0">{{schema.title}}</h2>
    }
    @if (schema.description) {
      <small>{{schema.description}}</small>
    }
  </div>
  <mat-radio-group [formControl]="aFormControl" class="flex flex-column" style="gap: 0.5rem;">
    @if (schema.examples && schema.examples.length > 0) {
      @for (option of schema.examples; track option) {
        <mat-radio-button
          [value]="option?.['value'] === null ? null : option?.['value']"
          [checked]="option?.['value'] === aFormControl.value"
        >
          @if (option?.['label']) {
            <span class="block">{{ option?.['label'] }}</span>
          }
          @if (option?.['description']) {
            <small>{{ option?.['description'] }}</small>
          }
        </mat-radio-button>
      }
    } @else {
      @for (option of schema.enum; track option) {
        <mat-radio-button
          [value]="option?.['value'] === null ? null : option?.['value']"
          [checked]="option?.['value'] === aFormControl.value"
        >
        </mat-radio-button>
      }
    }
  </mat-radio-group>
</div>
